"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _recompose = require("recompose");

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _withWidth = _interopRequireWildcard(require("@material-ui/core/withWidth"));

var _solarReact = require("@solar/solar-react");

var _DetailView = _interopRequireDefault(require("./DetailView"));

var _DetailViewCloseButton = _interopRequireDefault(require("./DetailViewCloseButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      flexShrink: 0,
      height: '100%'
    },
    // someState: {},
    shimAppBar: {
      backgroundColor: theme.palette.background.appBar
    },
    shimAppBarSmall: {
      height: 64
    }
  };
};

var actionBarContainerNodes = {};

var DetailViews = /*#__PURE__*/function (_Component) {
  _inherits(DetailViews, _Component);

  var _super = _createSuper(DetailViews);

  function DetailViews() {
    var _this;

    _classCallCheck(this, DetailViews);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      panelAvailable: {} // actionBarContainerNodes: [],

    });

    return _this;
  }

  _createClass(DetailViews, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.setState({
          panelAvailable: _this2.props.panels.map(function () {
            return true;
          })
        });
      }, this.props.theme.transitions.duration.shorter);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      var _this3 = this;

      if (newProps.panels.length !== this.props.panels.length) {
        setTimeout(function () {
          _this3.setState({
            panelAvailable: newProps.panels.map(function () {
              return true;
            })
          });
        }, this.props.theme.transitions.duration.shorter);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          CloseButton = _this$props.CloseButton,
          components = _this$props.components,
          history = _this$props.history,
          width = _this$props.width,
          onClose = _this$props.onClose,
          panels = _this$props.panels,
          maxPanels = _this$props.maxPanels,
          maxVisiblePanels = _this$props.maxVisiblePanels,
          panelWidth = _this$props.panelWidth,
          panelProps = _this$props.panelProps;
      var panelAvailable = this.state.panelAvailable;
      var isTabletUp = (0, _withWidth.isWidthUp)('sm', width);
      var visiblePanels = Math.min(maxVisiblePanels, panels.length);
      var all = Array.apply(void 0, _toConsumableArray(Array(maxPanels)));
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(classes.root),
        style: {
          width: visiblePanels * panelWidth
        }
      }, all.map(function (n, index) {
        var _panels$index;

        var DetailComponent = panels[index] ? components[panels[index].context].Component : function () {
          return null;
        };
        var shift = 0;

        if (isTabletUp && index < panels.length - 1) {
          // invisible Panels
          if (index < panels.length - visiblePanels) {
            shift = (visiblePanels - 1) * panelWidth + (panels.length - visiblePanels - index) * 80;
          } else {
            // visiblePanels
            shift = (panels.length - 1 - index) * panelWidth;
          }
        }

        return /*#__PURE__*/_react["default"].createElement(_DetailView["default"], {
          setActionBarContainerNode: function setActionBarContainerNode(node) {
            actionBarContainerNodes[index] = node;
          },
          key: // no problem to use index here: this list of panels will always be immutable
          // since maxPanels will not change after init
          index,
          open: !!panels[index],
          docked: false,
          width: isTabletUp ? panelWidth : '100vw',
          shift: shift
        }, panelAvailable[index] && /*#__PURE__*/_react["default"].createElement(DetailComponent, _extends({
          id: panels[index] && panels[index].id,
          history: history,
          queryParams: panels[index],
          getActionBarContainer: function getActionBarContainer() {
            return actionBarContainerNodes[index];
          },
          panel: panels === null || panels === void 0 ? void 0 : (_panels$index = panels[index]) === null || _panels$index === void 0 ? void 0 : _panels$index.context
        }, panelProps)), CloseButton ? /*#__PURE__*/_react["default"].createElement(CloseButton, {
          onClick: function onClick() {
            onClose(panels[index] && panels[index].context);
          }
        }) : /*#__PURE__*/_react["default"].createElement(_DetailViewCloseButton["default"], {
          onClick: function onClick() {
            onClose(panels[index] && panels[index].context);
          }
        }), /*#__PURE__*/_react["default"].createElement(_solarReact.ShimAppBar, {
          position: "static",
          className: (0, _classnames["default"])(classes.shimAppBar, !isTabletUp ? classes.shimAppBarSmall : '')
        }));
      }));
    }
  }]);

  return DetailViews;
}(_react.Component);

_defineProperty(DetailViews, "propTypes", {
  classes: _propTypes["default"].object.isRequired,
  className: _propTypes["default"].string,
  CloseButton: _propTypes["default"].func,
  components: _propTypes["default"].object.isRequired,
  history: _propTypes["default"].object,
  maxPanels: _propTypes["default"].number,
  maxVisiblePanels: _propTypes["default"].number,
  onClose: _propTypes["default"].func.isRequired,
  panelProps: _propTypes["default"].object,
  panels: _propTypes["default"].array.isRequired,
  panelWidth: _propTypes["default"].number,
  theme: _propTypes["default"].object.isRequired,
  width: _propTypes["default"].string.isRequired
});

_defineProperty(DetailViews, "defaultProps", {
  className: '',
  panelWidth: 72 * 7,
  maxPanels: 3,
  maxVisiblePanels: 2
});

var _default = (0, _recompose.compose)((0, _withWidth["default"])(), (0, _styles.withStyles)(styles, {
  withTheme: true
}))(DetailViews);

exports["default"] = _default;